import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './InformationSG.js.css';

export class InformationSG extends Component {
    constructor(props) {
        super(props);
        this.div = document.createElement('div');
        this.div.className = 'infoSG';
    }

    componentDidMount() {
        const element = document.getElementsByClassName('row')[2];
        element.appendChild(this.div);
    }

    componentWillUnmount() {
        const element = document.getElementsByClassName('row')[2];
        element.removeChild(this.div);
    }

    obtenirNomProvince() {
        const { province } = this.props.serviceGarde;
        let nomProvince;
        switch (province) {
            case 'QC':
                nomProvince = 'Québec';
                break;
            default:
                nomProvince = province;
        }
        return nomProvince;
    }

    formaterCodePostal() {
        const { codePostal } = this.props.serviceGarde;
        
        if (codePostal !== undefined && codePostal.length === 6) {
            return codePostal.slice(0, 3) + ' ' + codePostal.slice(3);
        }
        return codePostal;
    }

    render() {
        const { serviceGarde, afficherSantions, onClick } = this.props;
        const { nom, type, placesPermis, numeroCivique, rue, municipalite } = serviceGarde;

        return ReactDOM.createPortal(
            <>
                <div>
                    <strong>{nom}</strong> ({type} - {placesPermis} places)
                </div>
                <div>
                    {numeroCivique ? numeroCivique + ', ' : ''} {rue}
                </div>
                <div>
                    {municipalite}, {this.obtenirNomProvince()} {this.formaterCodePostal()}
                </div>
                <div>
                    {!afficherSantions ?
                        <button onClick={onClick}>Consulter les sanctions pénales</button>
                        :
                        <button onClick={onClick}>Page précédente</button>
                    }
                </div>
                <hr />
            </>
            , this.div);
    }
}
